import { Flex, Image } from '@chakra-ui/react';
import { cartridges } from '../cartridges';
import { Cartridge } from './Cartridge/cartridge';
import { CartridgeType } from '../setCartridgeType';

interface ICartridgeCarousel {
	currentCartridge: number;
}

export const CartridgeCarousel = ({ currentCartridge }: ICartridgeCarousel) => (
	<Flex
		position="relative"
		height="338px"
		width="600px"
	>
		<Cartridge
			type={0}
			current={currentCartridge}
		/>
		<Cartridge
			type={1}
			current={currentCartridge}
		/>
		<Cartridge
			type={2}
			current={currentCartridge}
		/>
	</Flex>
);
